var messages = {
  sharedFolderIconLabel: 'Shared Folder Icon',
  folderIconLabel: 'Folder Icon',
  fileIconLabel: 'File Icon',
  clearContentFieldButtonLabel: 'Clear Content Field',
  clearContentFieldIconLabel: 'Clear Content Field icon'
};
export { messages };